









































import { Component, Vue } from 'vue-property-decorator'
import { namespace } from 'vuex-class'
const smartMarketing = namespace('smartMarketing')

@Component
export default class CompanySettingsSmartMarketing extends Vue {
    @smartMarketing.State readonly saving!: boolean
    @smartMarketing.State readonly enabled!: boolean
    @smartMarketing.Getter readonly credentialsState!: string
    @smartMarketing.Getter readonly isActiveCampaign!: boolean
    @smartMarketing.Getter readonly isActivated!: boolean
    @smartMarketing.Getter readonly canUseActiveCampaign!: boolean
    @smartMarketing.Getter readonly canUseEmma!: boolean
    @smartMarketing.Action readonly load!: () => Promise<void>
    @smartMarketing.Action readonly save!: () => Promise<void>

    mounted(): void {
        this.load()
    }

    get tabEntries(): Array<{ label: string, route: string, isVisible: boolean }> {
        return [
            {
                label: this.$t('breadcrumbs.routes.company_settings_smart_marketing_general').toString(),
                route: 'company_settings_smart_marketing_general',
                isVisible: true,
            },
            {
                label: this.$t('breadcrumbs.routes.company_settings_smart_marketing_contacts').toString(),
                route: 'company_settings_smart_marketing_contacts',
                isVisible: this.enabled && this.isActivated,
            },
            {
                label: this.$t('breadcrumbs.routes.company_settings_smart_marketing_event').toString(),
                route: 'company_settings_smart_marketing_event',
                isVisible: this.canUseActiveCampaign,
            },
            {
                label: this.$t('breadcrumbs.routes.company_settings_smart_marketing_teams').toString(),
                route: 'company_settings_smart_marketing_teams',
                isVisible: (this.canUseActiveCampaign && this.$currentCompany.pipelinesEnabled)
                    || (this.canUseEmma && this.$currentCompany.pipelinesEnabled),
            },
            {
                label: this.$t('breadcrumbs.routes.company_settings_smart_marketing_webhooks').toString(),
                route: 'company_settings_smart_marketing_webhooks',
                isVisible: this.canUseActiveCampaign,
            },
            {
                label: this.$t('breadcrumbs.routes.company_settings_smart_marketing_realworks').toString(),
                route: 'company_settings_smart_marketing_realworks',
                isVisible: this.canUseActiveCampaign,
            },

        ].filter(tabEntry => tabEntry.isVisible)
    }
}
